export function makeId (length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length;
  for ( var i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export function debounce (fn, wait) {
  let timer
  return function (...args) {
    if (timer) clearTimeout(timer)
    const context = this
    timer = setTimeout(() => {
      fn.apply(context, args)
    }, wait)
  }
}

/**
 * Returns bytes converted to the bigger int number with or without unit
 * 
 * @param {number} x Bytes to convert
 * @param {number} base Base multiplier used for conversion (e.g. MiB 1024, MB 1000)
 * @param {boolean} add_unit Output the result with the unit string 
 * @returns {number, string} Converted bytes with or without unit
 */
export function niceBytes (x, base, add_unit = false) {
  const unit_names = {
    1000: ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    1024: ['bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
  }
  let l = 0, n = parseInt(x, 10) || 0
  while (n >= base && ++l) {
    n = n / base
  }
  const decimals = n < 10 && l > 0 ? 2 : 1 // 1 decimal for single digit (<10) results. 1 for bigger amounts (>10)
  const value = n.toFixed(decimals)
  const unit = ' ' + unit_names[base][l]
  return (add_unit) ? value + unit : value
}

export function splitFullName(fullName) {
  // Split the fullName string by the first space
  const [firstName, ...rest] = fullName.split(' ')

  // Join the remaining parts to form the surname
  const surname = rest.join(' ')

  return {
    firstName: firstName,
    surname: surname
  }
}

export function getBrowserLanguage () {
  const userLanguage = (navigator.languages && navigator.languages.length)
    ? navigator.languages[0]
    : navigator.language;

  const languageOnly = userLanguage.split(/[-_]/)[0] // Extract only the language code

  // Check for Dutch or Spanish, otherwise default to English
  if (languageOnly === 'nl') {
    return 'nl' // Dutch
  } else if (languageOnly === 'es') {
    return 'es' // Spanish
  } else {
    return 'en' // Default to English
  }
}

export function randomCelebName () {
  const celebrityNames = [
    'Michael Douglas',
    'Gordon Gekko',
    'Charlie Sheen',
    'Bud Fox',
    'Daryl Hannah',
    'Darien Taylor',
    'Martin Sheen',
    'Carl Fox',
    'Terence Stamp',
    'Sir Larry Wildman',
    'James Karen',
    'Hal Holbrook',
    'Lou Mannheim',
    'Sean Young',
    'Kate Gekko',
    'James Spader',
    'Roger Barnes'
  ];
  var randomIndex = parseInt(Math.random() * celebrityNames.length)
  return celebrityNames[randomIndex]
}

export function randomEmail (name) {
  const firsName = name.split(' ')[0]
  return firsName.toLowerCase() + '@example.com'
}

export function capitalize(s) {
  return String(s[0]).toUpperCase() + String(s).slice(1)
}

export function getHighContrastColor (color) {
  const rgbColor = hexToRgb(color)
  const grayscale = 0.299 * rgbColor.r + 0.587 * rgbColor.g + 0.114 * rgbColor.b
  const contrastColor = grayscale > 128 ? '#000000' : '#FFFFFF'

  return contrastColor
}

export function hexToRgb (color) {
  // Remove the hash if it exists
  const hex = color.replace(/^#/, '');

  // Parse the hex value into individual RGB components
  const bigint = parseInt(hex, 16)
  const r = (bigint >> 16) & 255
  const g = (bigint >> 8) & 255
  const b = bigint & 255

  return { r, g, b }
}

export function promptDownload (response) {
  const contentDisposition = response.headers['content-disposition']

  let filename = 'download.pdf'; // Default filename
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^";]+)"?/)
    if (match && match[1]) {
      filename = match[1] // Extract the actual filename
    }
  }

  const url = window.URL.createObjectURL(response.data)
  const a = document.createElement('a')
  a.href = url
  a.download = filename // Set the filename
  document.body.appendChild(a)
  a.click() // Trigger download
  document.body.removeChild(a)
  window.URL.revokeObjectURL(url) // Clean up
}

export function encodeQueryData (data) {
  var ret = []
  for (var d in data) {
    if (data[d]) {
      ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]))
    }
  }
  return ret.join("&")
}